// src/components/engineer-dashboard.js
import React from 'react';
import Sidebar from './Sidebar';
import '../App.css';
import '../responsive.css';

const EngDashboardPage = () => {
  return (
    <div className="DashboardPage">
      <header>Engineer Dashboard</header>
      <Sidebar role="engineer" />
      <div className="main-content">
        {/* Your main content goes here */}
      </div>
    </div>
  );
};

export default EngDashboardPage;
